<div class="create-card" (click)="createRoom()">
  <div class="create-text">Create New Room</div>
  <mat-icon class="add-icon">add_circle</mat-icon>
</div>
